module.exports = __webpack_public_path__ + "img/public-qr-code.e69e8661.png";